import { Drawer } from "@aurem/ui";
import { useCallback } from "react";
import { MoreContent } from "./MoreContent";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const MoreDrawer = ({ open, onClose }: Props) => {
  const handleOpenChange = useCallback(
    (isOpen: boolean) => {
      if (!isOpen) {
        onClose();
      }
    },
    [onClose],
  );

  return (
    <Drawer
      open={open}
      onOpenChange={handleOpenChange}
      side="bottom"
      className="inset-x-3.5 w-auto border-0 bg-transparent shadow-none pointer-events-none pb-[max(0.875rem,env(safe-area-inset-bottom))]"
    >
      {open && <MoreContent onClose={onClose} />}
    </Drawer>
  );
};
